export default __webpack_public_path__ + "static/media/pnsv_stand_Sigma.32df0905.png";